import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'datetimeShortener'
})
export class DatetimeShortenerPipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  transform(value: number): string {
    const cutoff = 24 * 60 * 60;
    const date = new Date(value * 1000);
    const diffSeconds = (Date.now() - date.getTime()) / 1000;

    if (diffSeconds > cutoff) {
      return date.toLocaleString();
    }

    const hoursAgo = Math.floor(diffSeconds / 60 / 60);
    if (hoursAgo === 0) {
      return this.transloco.translate('pipes.datetime.minsAgo', { mins: Math.floor(diffSeconds / 60)});
    }

    return this.transloco.translate('pipes.datetime.hoursAgo', { hours: hoursAgo });
  }
}

